module.exports = __webpack_public_path__ + "img/Stylus Concorde Pro G.3d98e327.png";